import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { PREVIEW_COACH_USER_ID } from "@/data/leaderPreviewData";

export interface CoachOnboardingState {
  onboarding_completed: boolean | null;
  coaching_focus?: string | null;
  updated_at?: string | null;
}

export function getCoachOnboardingStateQueryKey(coachId?: string) {
  return ["coach-onboarding-state", coachId] as const;
}

export async function fetchCoachOnboardingState(
  coachId?: string | null,
): Promise<CoachOnboardingState | null> {
  if (!coachId) return null;
  if (coachId === PREVIEW_COACH_USER_ID) {
    return {
      onboarding_completed: true,
      coaching_focus: "Preview coach guidance",
      updated_at: "2026-03-30T00:00:00.000Z",
    };
  }

  const { data, error } = await supabase
    .from("coach_onboarding")
    .select("onboarding_completed, coaching_focus, updated_at")
    .eq("coach_id", coachId)
    .maybeSingle();

  if (error) {
    console.error("Failed to load coach onboarding state:", error);
    throw error;
  }

  return data;
}

export function useCoachOnboardingState(
  coachId?: string | null,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: getCoachOnboardingStateQueryKey(coachId ?? undefined),
    queryFn: () => fetchCoachOnboardingState(coachId),
    enabled: (options?.enabled ?? true) && Boolean(coachId),
  });
}
